import React, { Component } from "react"
import Dashboard from "../Dashboard"
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import person_green from '../../utils/assets/images/person_green.png'
import entreprise_green from '../../utils/assets/images/entreprise_green.png'
import { Link, Redirect } from "react-router-dom"
import { connect } from 'react-redux'

import { 
  fetchReauthenticateMembersAction
} from  '../../actions/Authentification/Reauthenticate'

import {
  fetchReauthenticateCourtiersAction
} from  '../../actions/Authentification/ReauthenticateCourtiers'

class UserType extends Component {
  state = {
    isCurrentLoginCourtier: localStorage.getItem("isCurrentLoginCourtier"),
  }
  componentDidMount() {
    document.title = `Dashboard Membre | Utilisateur`

    const { isCurrentLoginCourtier } = this.state
    const { getReauthenticate, getReauthenticateCourtiers, reauthenticateMembers } = this.props

    if (isCurrentLoginCourtier) {
      getReauthenticateCourtiers()
    }else {
      if (Object.keys(reauthenticateMembers.userData).length === 0) {
        getReauthenticate()
      }
    }
  }

  render() {
    const { match, reauthenticateMembers, reauthenticateCourtiers } = this.props
    const { isCurrentLoginCourtier } = this.state

    return (
      <div>
        <Header userIsSuccessLogin={isCurrentLoginCourtier ? reauthenticateCourtiers.isSuccess : reauthenticateMembers.isSuccess} />
          {(reauthenticateMembers.isLoading || reauthenticateCourtiers.isLoading)
            ?
              <div className="aps-spinner-container-loading">
                <div className="uk-spinner">
                  <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                     <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="14"></circle>
                  </svg>
                </div>
                <div className="aps-section-register-desc">chargement en cours</div>
              </div>
            :
              <Dashboard match={match}>
                <div className="uk-grid-large uk-flex-center aps-dashboard-body-second-content aps-dashboard-user-type-container" data-uk-grid>
                  <Link to={{
                    pathname: '/souscripteur',
                    state: { fromParticulierSubscribe: true }
                  }} className=" uk-width-1-2 aps-dashboard-user-type-item uk-card uk-card-hover uk-card-body uk-flex uk-flex-column uk-flex-center border-all">
                    <img src={person_green} alt="arrow-right" />
                    <p className="uk-text-center aps-dashboard-user-type-title">Je suis une personne physique <br/> (Particulier)</p>
                  </Link>
                  <Link to={{
                    pathname: '/souscripteur',
                    state: { fromEntrepriseSubscribe: true }
                  }} className=" uk-width-1-2 aps-dashboard-user-type-item uk-card uk-card-hover uk-card-body uk-flex uk-flex-column uk-flex-center border-all">
                    <img src={entreprise_green} alt="arrow-right" className="aps-dashboard-user-type-entreprise-img" />
                    <p className="uk-text-center aps-dashboard-user-type-title">Je suis une personne morale <br/> (Entreprise)</p>
                  </Link>
                </div>
                {(reauthenticateMembers.isError && !isCurrentLoginCourtier) &&
                  <div>
                    <Redirect to='/connexion' push/>
                  </div>
                }
                {(reauthenticateCourtiers.isError && !isCurrentLoginCourtier) &&
                  <div>
                    <Redirect to='/connexion-intermediaires' push/>
                  </div>
                }
              </Dashboard>
          }
        <Footer/>
      </div>
    )
  }
}

const mapStateToProps = ({ reauthenticateMembers, reauthenticateCourtiers }) => {
  return {
    reauthenticateMembers,
    reauthenticateCourtiers,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getReauthenticate: () => dispatch(fetchReauthenticateMembersAction()),
    getReauthenticateCourtiers: () => dispatch(fetchReauthenticateCourtiersAction()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserType)



// WEBPACK FOOTER //
// ./src/containers/UserType/index.js